<template>
  <div>
    <el-menu
      :default-active="'/index'"
      router
      mode="horizontal"
      background-color="white"
      text-color="#222"
      active-text-color="red"
      style="min-width: 1300px">
      <a href="#nowhere" style="color: #222;float: right;padding: 20px;">更多功能</a>
      <i class="el-icon-menu" style="float:right;font-size: 45px;color: #222;padding-top: 8px"></i>
      <span style="position: absolute;padding-top: 20px;right: 43%;font-size: 20px;font-weight: bold">White Jotter - Your Mind Palace</span>
      <i class="el-icon-switch-button" v-on:click="logout"
         style="float:right;font-size: 40px;color: #222;padding: 10px">退出</i>
    </el-menu>
    <TaskList></TaskList>
  </div>
</template>

<script>
  import TaskList from '@/components/task/TaskList'
  export default {
    name: 'Home',
    components: {TaskList},
    methods: {
      logout() {
        var _this = this
        _this.$axios.post('/logout',{access_token:_this.$store.state.access_token}).then(resp => {
          if (resp.data.code === 200) {
            _this.$store.commit('logout')
            _this.$router.replace('/login')
          }
        })
      }
    }
  }
</script>

<style scoped>
  a {
    text-decoration: none;
  }

  span {
    pointer-events: none;
  }

  .el-icon-switch-button {
    cursor: pointer;
    outline: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Home.vue